export default "__VITE_ASSET__f90a5dcd__"